import { Component, Inject, OnInit } from '@angular/core';
import { SqlService } from '../../../Database/sql.service';
import { finalize } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-app-reports',
  templateUrl: './app-reports.component.html',
  styleUrls: ['./app-reports.component.css']
})
export class AppReportsComponent implements OnInit {
  filterType = 'Both';
  searchTerm = '';
  supervisorFilter = 'All';
  supervisors: string[] = [];
  private supervisorsInitialized = false;

  loading = false;
  error: string | null = null;

  rows: any[] = [];

  constructor(private sql: SqlService, @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.loadReports();
  }

  onFilterTypeChange() {
    if (this.filterType !== 'Agent') {
      this.supervisorFilter = 'All';
    }
  }

  loadReports() {
    this.loading = true;
    this.error = null;
    this.rows = [];

    const sup = this.supervisorFilter && this.supervisorFilter !== 'All' ? this.supervisorFilter : '';
    this.sql.getAppReports(this.filterType, this.searchTerm, sup)
      .pipe(finalize(() => this.loading = false))
      .subscribe((res: any) => {
        const mapped = (res || []).map((r: any) => ({
          ...r,
          lastLoginFormatted: this.formatDate(r.lastLoginAt),
          supervisorName: r.supervisorName || ''
        }));
        this.rows = mapped;

        // Build unique supervisors list only once (do not change on subsequent searches)
        if (!this.supervisorsInitialized) {
          const supSet: Set<string> = new Set();
          mapped.forEach((row: any) => {
            if (row.userType === 'agent' && row.supervisorName && row.supervisorName.trim() !== '') {
              supSet.add(row.supervisorName.trim());
            }
          });
          const supList = Array.from(supSet).sort();
          this.supervisors = ['All', ...supList];
          this.supervisorsInitialized = true;
          // keep previous selection if still valid
          if (this.supervisorFilter !== 'All' && !this.supervisors.includes(this.supervisorFilter)) {
            this.supervisorFilter = 'All';
          }
        }
      }, err => {
        console.error(err);
        this.error = 'Failed to load reports.';
      });
  }

  

  exportToExcel() {
    const sup = this.supervisorFilter && this.supervisorFilter !== 'All' ? this.supervisorFilter : '';
    const url = this.sql.exportAppReports(this.filterType, this.searchTerm, sup);
    // Open in new window to trigger download
    window.open(url, '_blank');
  }

  onSearch() {
    this.loadReports();
  }

  onClear() {
    this.filterType = 'Both';
    this.searchTerm = '';
    this.supervisorFilter = 'All';
    this.loadReports();
  }

  clearSearchInput() {
    this.searchTerm = '';
  }

  private formatDate(v: any): string {
    if (!v) return '';
    // Strings and numbers are straightforward
    if (typeof v === 'string' || typeof v === 'number') {
      const d = new Date(v);
      if (!isNaN(d.getTime())) return d.toLocaleString();
      return String(v);
    }

    if (typeof v === 'object') {
      // sqlsrv often returns an object with a 'date' property
      if ('date' in v) {
        const candidate: any = (v as any).date;
        const d = new Date(candidate);
        if (!isNaN(d.getTime())) return d.toLocaleString();
      }

      // Try common property names
      if ('value' in v) {
        const d = new Date((v as any).value);
        if (!isNaN(d.getTime())) return d.toLocaleString();
      }

      // Try to extract an ISO timestamp from JSON
      try {
        const s = JSON.stringify(v);
        const iso = s.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/);
        if (iso) {
          const d = new Date(iso[0]);
          if (!isNaN(d.getTime())) return d.toLocaleString();
        }
      } catch (e) {}

      // Fallback to .toString()
      try {
        const s = (v as any).toString();
        const d = new Date(s);
        if (!isNaN(d.getTime())) return d.toLocaleString();
        return s;
      } catch (e) {
        return String(v);
      }
    }

    return String(v);
  }
}
